import {GET_RELATIVES} from "../../../../enums/Profile/profile";

export const getRelativesInformationAction = (data)=>{
    return{
        type:GET_RELATIVES,
        payload:data,
    };

};
